import useThemeProps from '../styles/useThemeProps';
export { default as styled } from '../styles/styled';

// eslint-disable-next-line @typescript-eslint/no-unused-vars
export function createUseThemeProps(name) {
  return useThemeProps;
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/@mui/material/zero-styled/index.js
// module id = 490
// module chunks = 0